import React, { useState } from "react";
import { Link } from "react-router-dom";

// 🧩 Define product type (you can also import this from your global `ProductItem` interface)
interface ProductItem {
  id: number | string;
  title: string;
  slug: string;
  proImg: string;
  price: number;
  delPrice?: number;
}

// 🧩 Props Interface
interface ShopProductProps {
  products: ProductItem[];
  addToCartProduct: (product: ProductItem) => void;
  addToWishListProduct: (product: ProductItem) => void;
}

const ShopProduct: React.FC<ShopProductProps> = ({
  products,
  addToCartProduct,
  addToWishListProduct,
}) => {
  const [count, setCount] = useState<number>(8);
  const [buttonActive, setButtonActive] = useState<boolean>(false);

  const ClickHandler = () => {
    window.scrollTo({ top: 10, behavior: "smooth" });
  };

  const handleLoadMore = () => {
    setCount((prev) => prev + 8);
    if (count >= products.length) setButtonActive(true);
  };

  return (
    <section className="wpo-product-section section-padding">
      <div className="container">
        <div className="wpo-product-wrap">
          <div className="row">
            {products.length > 0 &&
              products.slice(0, count).map((product) => (
                <div
                  className="col-xl-3 col-lg-6 col-md-6 col-12"
                  key={product.id}
                >
                  <div className="wpo-product-item">
                    <div className="wpo-product-img">
                      <img src={product.proImg} alt={product.title} />
                      <ul>
                        <li>
                          <button
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Wishlist"
                            onClick={() => addToWishListProduct(product)}
                          >
                            <i className="fi flaticon-heart"></i>
                          </button>
                        </li>
                        <li>
                          <button
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Cart"
                            onClick={() => addToCartProduct(product)}
                          >
                            Add To Cart
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div className="wpo-product-text">
                      <h3>
                        <Link
                          onClick={ClickHandler}
                          to={product.slug ? `/product-single/${product.slug}` : "#"}
                        >
                          {product.title}
                        </Link>
                      </h3>
                      <ul>
                        {product.delPrice && <li>${product.delPrice}</li>}
                        <li>${product.price}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {!buttonActive && products.length > count && (
            <div className="load-btn text-center mt-3">
              <button
                className="loadmore-btn theme-btn"
                onClick={handleLoadMore}
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ShopProduct;
